import React, { useState } from 'react';
import { ShoppingBagIcon } from 'lucide-react';
import BackButton from '../../../components/UI/BackButton';
import { useMerchShelf } from './useMerchShelf';
import { SearchFilters } from './SearchFilters';
import { ItemGrid, CoverCarousel, MerchInfoModal, MerchHoverCard } from './ItemDisplay';
const MerchShelf = () => {
  const {
    category,
    searchTerm,
    setSearchTerm,
    showFilters,
    setShowFilters,
    sortOption,
    setSortOption,
    darkMode,
    hoveredItemId,
    setHoveredItemId,
    mousePosition,
    sortedItems,
    navigateToCategory,
    navigateToEdit,
    navigate
  } = useMerchShelf();
  const [selectedItem, setSelectedItem] = useState<any | null>(null);
  const isMobile = typeof window !== 'undefined' && window.innerWidth < 768;
  const tabs = [{
    label: 'All Products',
    key: undefined
  }, {
    label: 'Clothing',
    key: 'clothing'
  }, {
    label: 'Accessories',
    key: 'accessories'
  }, {
    label: 'Art Prints',
    key: 'art-prints'
  }, {
    label: 'Home & Living',
    key: 'home-living'
  }];
  return <div className={`min-h-screen ${darkMode ? 'bg-gray-900 text-gray-100' : 'bg-gray-50 text-gray-900'} py-8`} data-id="element-20023" data-mp="fvz1ruqwoqlw">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-20024" data-mp="puet9ytui1vx">
        <div className="mb-6" data-id="element-20025" data-mp="puwkui5kbrxi">
          <div className="mb-3" data-id="element-20026" data-mp="psk2w4zt1hkg">
            <BackButton data-id="element-20027" data-mp="240zo3vm3uz8" />
          </div>
          <h1 className={`text-2xl font-bold ${darkMode ? 'text-white' : 'text-gray-900'}`} data-id="element-20028" data-mp="252963wzc9eu">
            Merch Catalog
          </h1>
          <p className={`mt-1 text-sm ${darkMode ? 'text-gray-300' : 'text-gray-600'}`} data-id="element-20029" data-mp="axdxnk8j9ms6">
            Manage your merchandise offerings
          </p>
        </div>

        <div className={`mb-6 flex space-x-1 overflow-x-auto border-b ${darkMode ? 'border-gray-700' : 'border-gray-300'}`} data-id="element-20030" data-mp="3elpedeckv3pu">
          {tabs.map(tab => <button key={tab.label} onClick={() => tab.key ? navigateToCategory(tab.key) : navigate('/merch/shelf')} className={`py-2 px-4 font-medium whitespace-nowrap ${category === tab.key ? `border-b-2 border-purple-600 ${darkMode ? 'text-purple-400' : 'text-purple-600'}` : `${darkMode ? 'text-gray-400 hover:text-purple-400' : 'text-gray-600 hover:text-purple-600'}`}`} data-id="element-20031" data-mp="1djzn40e4o5rw">
              {tab.label}
            </button>)}
        </div>

        <SearchFilters searchTerm={searchTerm} setSearchTerm={setSearchTerm} showFilters={showFilters} setShowFilters={setShowFilters} sortOption={sortOption} setSortOption={setSortOption} darkMode={darkMode} data-id="element-20032" data-mp="zjf699rrwk11" />

        <div className={`${darkMode ? 'bg-gray-800' : 'bg-white'} rounded-lg shadow-md p-6 mb-8`} data-id="element-20033" data-mp="2fyzys4tdhiji">
          {sortedItems.length > 0 ? <ItemGrid items={sortedItems} darkMode={darkMode} onItemClick={item => setSelectedItem(item)} onHoverEnter={id => !isMobile && setHoveredItemId(id)} onHoverLeave={() => setHoveredItemId(null)} data-id="element-20034" data-mp="2kznu32omwljj" /> : <div className="text-center py-12" data-id="element-20035" data-mp="3vng0l0mqj5pa">
              <ShoppingBagIcon className={`h-12 w-12 ${darkMode ? 'text-gray-600' : 'text-gray-400'} mx-auto mb-4`} data-id="element-20036" data-mp="3qpo3ls78gte8" />
              <h3 className={`text-lg font-medium mb-2 ${darkMode ? 'text-gray-200' : 'text-gray-900'}`} data-id="element-20037" data-mp="3lp9zgl8r63lh">
                No products found
              </h3>
              <p className={darkMode ? 'text-gray-400' : 'text-gray-500'} data-id="element-20038" data-mp="3ct10f7oot6zv">
                Try adjusting your search or filters
              </p>
            </div>}
        </div>
      </div>

      {!isMobile && hoveredItemId && (() => {
      const item = sortedItems.find(i => i.id === hoveredItemId);
      return item ? <MerchHoverCard item={item} darkMode={darkMode} mousePosition={mousePosition} data-id="element-20039" data-mp="3odpeq3p6jq2" /> : null;
    })()}

      {selectedItem && <MerchInfoModal item={selectedItem} darkMode={darkMode} onClose={() => setSelectedItem(null)} onEdit={navigateToEdit} data-id="element-20040" data-mp="3pthcg5fz1p2a" />}
    </div>;
};
export default MerchShelf;